import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import {
  Button,
  Modal,
  ModalBody,
  Input,
  Form,
  Row,
  Col,
  Label,
} from "reactstrap";
import PropTypes from "prop-types";
import Dropzone from "react-dropzone";
import { connect } from "react-redux";
import moment from "moment"

// IMPORT CONFIG
import { getCacheImage } from "../../config";

// IMPORT UTILS
import { convertToRupiah } from "../../utils"

// IMPORT ACTION
import {
  fetchAllCourier,
  getHistoryShipping,
  postPickUpIdExpress,
  fetchPickupIDExpressSettings,
  postCancelPickUpIdExpress,
  getShippingFee
} from "../../actions/postalCodeAction";

// IMPORT COMPONENTS
import ModalAddressBookIdExpress from "./ModalAddressBookIdExpress";
import ModalAddressBookV2 from "./ModalAddressBookV2";
import ModalConfirmation from "./ModalConfirmation";
import ModalTrackingNumber from "./ModalTrackingNumber";

// IMPORT ASSETS
import CloseIcon from "../../images/close-button-black.png";
import CloseIconBlack from "../../images/close-button-black.png";
import TruckImg from "../../images/truck-img.png";
import Back from "../../images/back.png";
import Next from "../../images/next.png";
import PinAddress from "../../images/pin-address.png";
import BrowseImg from "../../images/picture.png";
import ArrowDown from "../../images/arrowDown.png";
import ShippingNotAvailable from "../../images/shippingnotavailable.png";

class AWB extends Component {
  constructor(props) {
    super(props);

    this.state = {
      awbNumber: "",
      maxUploads: 1,
      files: [],
      _error: null,
      shippingOption: "",
      shippingToggle: false,
      otherShipping: "",
      openIdExpressModal: true,
      idExpressProcess: "",
      isAddressBookOpen: false,
      _error: "",
      selectedAddress: {},
      isSubmit: false,
      isSubmitPickUpSuccess: false,
      shippingId: null,
      defaultId: 0,
      selectedShipping: null,
      isErrorPickUpIdExpress: null,
      isErrorModalOpen: false,
      errorMessage: null,
      seller_pickup_start: null,
      seller_pickup_end: null,
      seller_awb_number: null,
      id_express_sale_id: null,
      openModalConfirmation: false,
      isOpenModalTracking: false,
      sale_id: 0,
      dataSaleForIdExpress: null,
      isIdExpressDisable: false,
      isAddressButtonDisable: false,
      shipping_fee: 0,
      discount: 0,
      shipping_fee_pending: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this._handleSelectedAddress = this._handleSelectedAddress.bind(this);
    this.changeId = this.changeId.bind(this);
    this.submitShipping = this.submitShipping.bind(this);
    this.setDefaultId = this.setDefaultId.bind(this);
    this.toggleModalTracking = this.toggleModalTracking.bind(this);
  }

  componentDidMount() {
    this.props.fetchAllCourier();
    this.props.fetchPickupIDExpressSettings();
    this.props.getHistoryShipping().then(() => {
      this.setState({
        selectedAddress:
          this.props.historyShipping && this.props.historyShipping.data.length > 0 && this.props.historyShipping.data[0],
      });
    });
  }

  setShippingId(id) {
    this.setState({
      shippingId: id,
      isAddressButtonDisable: false
    })
  }

  changeId(id) {
    this.setState({
      shippingId: id,
      isAddressButtonDisable: true
    })
  }

  setDefaultId(id) {
    this.setState({
      defaultId: id,
    })
  }

  setSelectedShipping(id) {
    this.setState({
      selectedShipping: id
    })
  }

  submitShipping(id) {
    if (id) {
      this.setDefaultId(id)
      const temp = this.props.historyShipping.data.filter(item => item.id === id)[0]
      this.setSelectedShipping(temp.alias)
      this.setShippingId(temp.id)
      this.handleModalAddressToggle()
    } else {
      this.setDefaultId(this.state.shippingId)
      const temp = this.props.historyShipping.data.filter(item => item.id === this.state.shippingId)[0]
      this._handleSelectedAddress(!temp ? this.state.selectedAddress : temp)
      this.setSelectedShipping(!temp ? this.state.selectedAddress.alias : temp.alias)
      this.setShippingId(!temp ? this.state.selectedAddress.id : temp.id)
      this.handleModalAddressToggle()
    }
  }

  handleChange(e) {
    this.setState({
      awbNumber: e.target.value,
    });
  }

  onSubmit() {
    const dataPayload = {
      seller_courier: this.state.otherShipping,
      awb: this.state.awbNumber,
      awb_image: this.state.files,
    };


    if (this.state.shippingToggle) {
      dataPayload.seller_courier = this.state.otherShipping;
    }

    this.props.onSubmit(dataPayload);
  }

  onDrop = (files) => {
    this.setState({ files });
  };

  handleShipping = (e) => {
    if (e.target.value === "others") {
      this.setState({
        shippingToggle: true,
        shippingOption: e.target.value,
      });
    } else {
      this.setState({
        shippingOption: e.target.value,
        shippingToggle: false,
      });
    }
  };

  handleOtherShipping = (e) => {
    this.setState({
      otherShipping: e.target.value,
    });
  };

  handleModalAddressToggle = () => {
    this.setState({
      isAddressBookOpen: !this.state.isAddressBookOpen,
    });
  };

  _handleSelectedAddress(item) {
    this.setState({
      isAddressBookOpen: !this.state.isAddressBookOpen,
      _error: "",
      selectedAddress: item,
      shipping_fee_pending: true
    }, () => {
      this.getShippingFee()
    });
  }

  _handleSubmitPickUp = () => {
    const { id: shipping_id } = this.state.selectedAddress
    const sale_id = this.props.dataSaleForIdExpress.data && this.props.dataSaleForIdExpress.data[0].id
    const payload = {
      service_type: "pickup",
      shipping_id,
      sale_id
    }

    this.props.postPickUpIdExpress(payload).then((res) => {
      const { seller_awb_number, seller_pickup_start, seller_pickup_end } = res.value.data
      this.props.refreshAfterSubmitAwb()
      this.setState({
        idExpressProcess: "process-success",
        seller_awb_number: seller_awb_number,
        seller_pickup_start: seller_pickup_start,
        seller_pickup_end: seller_pickup_end,
        id_express_sale_id: sale_id
      })
    }).catch((err) => {
      this.setState({
        isErrorModalOpen: !this.state.isErrorModalOpen,
        errorMessage: this.props.IdExpressPickUpProcess.error && this.props.IdExpressPickUpProcess.errors ? this.props.IdExpressPickUpProcess.error.errors.desc : this.props.IdExpressPickUpProcess.error.message,
        idExpressProcess: "id-express-error-message"
      })
    })
  }

  toggleIdExpressErrorModal = () => {
    this.setState({
      isErrorModalOpen: !this.state.isErrorModalOpen
    })
  }

  IdExpressErrorMessage = () => {
    if (!this.state.isErrorModalOpen) {
      return null
    }
    return (
      <Modal isOpen={this.state.isErrorModalOpen} toggle={this.toggleIdExpressErrorModal}>
        <div>
          <p>{this.state.errorMessage}</p>
        </div>
      </Modal>
    )
  }

  toggleModalTracking = (id = 0, dataSale = null) => {
    this.setState({
      isOpenModalTracking: !this.state.isOpenModalTracking,
      sale_id: id,
      dataSaleForIdExpress: dataSale
    })
  }

  // RENDER MODAL TRACKING
  renderTrackinModal = (id, dataSale) => {
    const { invoice_number, seller_awb_number, seller_courier, seller_sent } = dataSale.data[0]

    return <ModalTrackingNumber
      isOpen={this.state.isOpenModalTracking}
      onToggle={this.toggleModalTracking}
      saleId={id}
      status={"seller"}
      orderId={invoice_number}
      deliverAt={seller_sent}
      shippingCourier={seller_courier}
      awbNumber={seller_awb_number}
    />
  }

  getShippingFee = () => {
    const {
      id: shipping_id
    } = this.state.selectedAddress;

    const weight = this.props.dataSaleForIdExpress.data[0] && this.props.dataSaleForIdExpress.data[0].sale_product.weight

    const payload = {
      shipping_id,
      weight
    }

    this.props.getShippingFee(payload)
      .then(({ value }) => this.setState({
        shipping_fee: value.data.shipping_fee,
        shipping_fee_pending: false,
        shippingDiscount: value.data.discount
      }))
  }

  ModalIDExpress = () => {
    if (this.props.dataSaleForIdExpress.data[0] && this.props.dataSaleForIdExpress.data[0].seller_courier) {
      var { seller_courier, seller_pickup_end, seller_pickup_start, id: sale_id, seller_awb_number: awb_number } = this.props.dataSaleForIdExpress.data[0]
    }

    // CANCEL AFTER SUBMIT
    if (seller_courier === "IDExpress") {
      const isCancelAndTracking = moment().format() > moment(seller_pickup_start).format() && moment().format() > moment(seller_pickup_end).format()
      return (
        <>
          <div className="truck-img-wrapper truck-img-waiting-req">
            <KickImage className="tuk-tuk-img" src={TruckImg} alt="..." />
          </div>
          <div className="id-express-content">
            <div className={`id-express-content-title process-success-content-title ${isCancelAndTracking ? "is-cancel-and-tracking" : ""}`}>
              <p className="choose-courier-text waiting-courier-idexpress-text">Waiting ID Express to pickup your package</p>
              {
                moment().format() < moment(seller_pickup_end).format() ?
                  <>
                    <p>ID Express will pick your package at</p>
                    <p><span className="id-express-pickup-estimation-timer">{moment(seller_pickup_start).format('h:mm a')} - {moment(seller_pickup_end).format('h:mm a')}</span> (est.)</p>
                  </>
                  :
                  <>
                    <p>ID Express is taking longer than expected to pick up your package. </p>
                    <p>If you have any questions pelase contact us via Line.</p>
                  </>
              }
            </div>
            {
              moment().format() > moment(seller_pickup_start).format() &&
              <div className={`button-express pick-address-btn waiting-req-btn tracking-number ${isCancelAndTracking ? "tracking-number-is-tracking-cancel" : ""}`}>
                <p
                  onClick={() => this.toggleModalTracking(sale_id, this.props.dataSaleForIdExpress)}
                  style={{ cursor: "pointer" }}
                ><u>Tracking Number</u></p>
              </div>
            }
            {
              (moment().format() < moment(seller_pickup_start).format() || moment().format() > moment(seller_pickup_end).format()) &&
              <div className="button-express pick-address-btn waiting-req-btn"
                onClick={() => {
                  this.setState({
                    openModalConfirmation: !this.state.openModalConfirmation
                  })
                }}
              >
                <p style={{ color: "red", cursor: "pointer" }}>CANCEL</p>
              </div>
            }
            <ModalConfirmation
              isOpen={this.state.openModalConfirmation}
              isToggle={() => this.setState({
                openModalConfirmation: !this.state.openModalConfirmation
              })}
              title={"Are you sure you want to cancel this pick up process?"}
              handleOption={() => {
                this.props.postCancelPickUpIdExpress({ sale_id, awb_number })
                  .then(() => {
                    this.props.refreshAfterSubmitAwb()
                  })
                  .then(() => this.props.onToggle())
                  .catch(err => {
                    this.setState({
                      isErrorModalOpen: !this.state.isErrorModalOpen,
                      errorMessage: this.props.CancelIdExpressPickUpProcess.error && this.props.CancelIdExpressPickUpProcess.error && this.props.CancelIdExpressPickUpProcess.error.desc,
                      idExpressProcess: "id-express-error-message"
                    })
                  })
              }}
            />
          </div>
        </>
      );
    }

    // Choose Courier
    const { idExpressProcess } = this.state;
    const { isEnabledPickupIdExpress } = this.props;

    if (idExpressProcess == "") {
      return (
        <>
          <div className="truck-img-wrapper initial-modal">
            <KickImage className="tuk-tuk-img" src={TruckImg} alt="..." />
          </div>
          <div className="id-express-content">
            <div className="id-express-content-title">
              <p className="choose-courier-text">Choose courier</p>
            </div>
            <div className="id-express-choose-courier-button">
              <div
                className="button-express"
                onClick={() =>
                  isEnabledPickupIdExpress ?
                    this.setState({
                      idExpressProcess: "choose-service"
                    }) :
                    this.setState({
                      idExpressProcess: "id-express-error-message",
                      isErrorModalOpen: true,
                      isIdExpressDisable: true
                    })
                }
              >
                <p>ID Express</p>
              </div>
              <div
                className="button-express"
                onClick={() => this.setState({ openIdExpressModal: false })}
              >
                <p>Other courier</p>
              </div>
            </div>
          </div>
        </>
      );
    }

    // Choose Service
    if (idExpressProcess == "choose-service") {
      return (
        <>
          <div className="truck-img-wrapper">
            <KickImage className="tuk-tuk-img" src={TruckImg} alt="..." />
          </div>
          <div className="id-express-content">
            <div className="id-express-content-title">
              <p className="choose-courier-text">Choose a service</p>
            </div>
            <div className="id-express-choose-courier-button">
              {isEnabledPickupIdExpress && (
                <div
                  className="button-express"
                  onClick={() => {
                    this.getShippingFee()
                    this.setState({ idExpressProcess: "choose-pickup-address" })
                  }}
                >
                  <p>Pick Up</p>
                </div>
              )}
              {/* INCOMING FUTURE */}
              {/* <div className="button-express">
                <p>Drop Off</p>
              </div> */}
            </div>
          </div>
        </>
      );
    }

    // Choose Pick Up Address
    if (idExpressProcess == "choose-pickup-address") {
      const {
        alias,
        full_name,
        street_address,
        city,
        province,
        postal_code,
        id: shipping_id
      } = this.state.selectedAddress;

      const {
        shipping_fee,
        shippingDiscount
      } = this.state

      return (
        <>
          {
            this.state.isAddressBookOpen &&
            <ModalAddressBookV2
              isOpen={this.state.isAddressBookOpen}
              onToggle={this.handleModalAddressToggle}
              dataAddress={this.props.historyShipping.data}
              countries={this.props.countries}
              provinces={this.props.provinces}
              cities={this.props.cities}
              id={this.state.shippingId ? this.state.shippingId : this.state.selectedAddress.id}
              changeId={this.changeId}
              defaultId={this.state.defaultId}
              submitShipping={this.submitShipping}
              getHistoryShipping={this.props.getHistoryShipping}
              handleSelectedAddress={this._handleSelectedAddress}
              isModalOffer={true}
              isAddressButtonDisable={this.state.isAddressButtonDisable}
            />
          }
          <div className="truck-img-wrapper address-modal">
            <KickImage className="tuk-tuk-img" src={TruckImg} alt="..." />
          </div>
          <div className="id-express-content">
            <div className="id-express-content-title">
              <p className="choose-courier-text">Choose pickup address</p>
            </div>
            <div className="id-express-choose-courier-button">
              <div className="button-express pick-address-choose-address">
                <div className="pin-img-wrapper">
                  <KickImage src={PinAddress} alt="..." />
                </div>
                <div
                  className="address-description"
                  onClick={async () => {
                    this.handleModalAddressToggle();
                  }}
                >
                  <p>Pick up address</p>
                  {
                    this.state.selectedAddress ?
                      <>
                        <p>
                          {alias} - {full_name}
                        </p>
                        <p>
                          {street_address}, {city}
                        </p>
                        <p>
                          {province} {postal_code}
                        </p>
                      </>
                      :
                      <>
                        <p>You haven’t added any address yet.</p>
                        <p style={{ fontSize: "12px" }}>Please enter an address to continue</p>
                      </>
                  }
                </div>
                <div className="next-img-wrapper">
                  <KickImage src={Next} alt="..." />
                </div>
              </div>
              <div className="idexpress-shipping-fee">
                <div className="text-delivery">
                  <p>Delivery Fee</p>
                  <div className="price-wrapper">
                    {
                      shippingDiscount !== 0 && shipping_fee !== 0 && <p className="shipping-fee-not-exist discount-price">IDR <s>{convertToRupiah(shipping_fee + shippingDiscount)}</s></p>
                    }
                    <p className={`${shipping_fee === 0 ? "shipping-fee-not-exist" : ""}`}>IDR {convertToRupiah(shipping_fee)}</p>
                  </div>
                </div>
                <p>Shipping fee will be automatically taken from the revenue after the sales completed.</p>
              </div>

              <div className="button-express pick-address-btn"
                onClick={() => this.state.selectedAddress && !this.state.shipping_fee_pending && this._handleSubmitPickUp()}
              >
                <p>SUBMIT</p>
              </div>
            </div>
          </div>
        </>
      );
    }

    // Waiting req
    if (idExpressProcess === "process-success") {
      const isCancelAndTracking = moment().format() > moment(this.state.seller_pickup_start).format() && moment().format() > moment(this.state.seller_pickup_end).format()
      return (
        <>
          <div className="truck-img-wrapper truck-img-waiting-req">
            <KickImage className="tuk-tuk-img" src={TruckImg} alt="..." />
          </div>
          <div className="id-express-content">
            <div className={`id-express-content-title process-success-content-title ${isCancelAndTracking ? "is-cancel-and-tracking" : ""}`}>
              <p className="choose-courier-text waiting-courier-idexpress-text">Waiting ID Express to pickup your package</p>
              {
                moment().format() < moment(this.state.seller_pickup_end).format() ?
                  <>
                    <p>ID Express will pick your package at</p>
                    <p><span className="id-express-pickup-estimation-timer">{moment(this.state.seller_pickup_start).format('h:mm a')} - {moment(this.state.seller_pickup_end).format('h:mm a')}</span> (est.)</p>
                  </>
                  :
                  <>
                    <p>ID Express is taking longer than expected to pick up your package. </p>
                    <p>If you have any questions pelase contact us via Line.</p>
                  </>
              }
            </div>
            {
              moment().format() > moment(this.state.seller_pickup_start).format() &&
              <div className="button-express pick-address-btn waiting-req-btn tracking-number">
                <p
                  onClick={() => this.toggleModalTracking(sale_id, this.props.dataSaleForIdExpress)}
                  style={{ cursor: "pointer" }}
                ><u>Tracking Number</u></p>
              </div>
            }
            {
              ((moment().format() < moment(this.state.seller_pickup_start).format()) || (moment().format() > moment(this.state.seller_pickup_end).format())) &&
              <div className="button-express pick-address-btn waiting-req-btn"
                onClick={() => {
                  this.setState({
                    openModalConfirmation: !this.state.openModalConfirmation
                  })
                }}
              >
                <p style={{ color: "red", cursor: "pointer" }}>CANCEL</p>
              </div>
            }
            <ModalConfirmation
              isOpen={this.state.openModalConfirmation}
              isToggle={() => this.setState({
                openModalConfirmation: !this.state.openModalConfirmation
              })}
              title={"Are you sure you want to cancel this pick up process?"}
              handleOption={() => {
                this.props.postCancelPickUpIdExpress({ sale_id: this.state.id_express_sale_id, awb_number: this.state.seller_awb_number })
                  .then(() => {
                    this.props.refreshAfterSubmitAwb()
                  })
                  .then(() => this.props.onToggle())
              }}
            />
          </div>
        </>
      );
    }

    // ERRO MESSAGE
    if (idExpressProcess === "id-express-error-message") {
      return (
        <>
          <div className="truck-img-wrapper truck-img-waiting-req">
            <KickImage className="tuk-tuk-img" src={ShippingNotAvailable} alt="..." />
          </div>
          <div className="id-express-content">
            <div className="id-express-content-title">
              {!this.state.errorMessage ?
                (
                  <>
                    <p className="choose-courier-text">ID Express is not available</p>
                    <p>{!this.state.isIdExpressDisable ? "ID Express Shipping is currently not available." : "Please try again later or use other courier"}</p>
                    <p>{!this.state.isIdExpressDisable ? "Please contact us." : ""}</p>
                  </>
                ) : (
                  <p>{this.state.errorMessage}</p>
                )}
            </div>
            <div className="button-express pick-address-btn waiting-req-btn close-button-error-modal"
              onClick={() => this.setState({ idExpressProcess: "", errorMessage: null, isIdExpressDisable: false })}
              style={{ cursor: "pointer", marginTop: "65px" }}
            >
              <p>CLOSE</p>
            </div>
          </div>
        </>
      );
    }
  };

  render() {
    const { listOfCouriers } = this.props;
    const { shippingToggle, shippingOption } = this.state;
    const isOpenIdExpress = ~document.location.hostname.indexOf("staging.kickavenue.com") || ~document.location.hostname.indexOf("devweb.kickavenue.com") ? this.state.openIdExpressModal : false;

    if (isOpenIdExpress) {
      const isShowBackButton = this.state.idExpressProcess == "choose-service" || this.state.idExpressProcess == "choose-pickup-address"
      return (
        <Modal
          isOpen={this.props.isOpen}
          toggle={this.props.onToggle}
          className="id-express-modal"
        >
          <div className={`id-express-wrapper ${this.state.idExpressProcess == "process-success" ? "success-content" : ""} ${this.state.idExpressProcess == "choose-pickup-address" ? "choose-pickup-address-wrapper" : ""}`}>
            <div className="id-express-icon-header-wrapper">
              {
                isShowBackButton &&
                <div className="back-img-wrapper">
                  <KickImage
                    className="back-img"
                    src={Back}
                    alt="..."
                    onClick={() => this.setState({ idExpressProcess: this.state.idExpressProcess == "choose-pickup-address" ? "choose-service" : "" })}
                  />
                </div>
              }
              <div className="close-icon-container">
                <KickImage
                  style={{
                    cursor: "pointer",
                    width: "15px",
                    objectFit: "contain"
                  }}
                  onClick={() => {
                    this.props.onToggle()
                  }}
                  src={CloseIconBlack}
                  alt="..."
                />
              </div>
            </div>
            {this.ModalIDExpress()}
            {this.state.isOpenModalTracking && this.renderTrackinModal(this.state.sale_id, this.state.dataSaleForIdExpress)}
          </div>
        </Modal>
      );
    }

    return (
      <Modal
        isOpen={this.props.isOpen}
        toggle={this.props.onToggle}
        className="kick-modal detail-selling"
      >
        <div className="header-expiry">
          <div className="close-icon-wrapper back-img-wrapper">
            <KickImage
              className="back-img"
              src={Back}
              alt="..."
              onClick={() => this.setState({ idExpressProcess: "", openIdExpressModal: true })}
            />
          </div>
          <div className="tracking-wrapper">
            <span>INPUT AWB NUMBER</span>
          </div>
          <div className="close-icon-wrapper">
            <KickImage
              style={{ cursor: "pointer" }}
              onClick={this.props.onToggle}
              src={CloseIcon}
              alt="..."
            />
          </div>
        </div>
        <ModalBody>
          <Row>
            <Col className="col-not-center">
              <Form>
                <Label>Shipping Courier</Label>
                {shippingToggle ? (
                  <>
                    <Input
                      style={{ background: `url(${ArrowDown})` }}
                      value={shippingOption}
                      onChange={this.handleShipping}
                      type="select"
                    >
                      <option value="" disabled selected hidden>
                        Select Courier
                      </option>
                      {listOfCouriers &&
                        listOfCouriers.map((item) => {
                          return (
                            <option value={item.code}>
                              {item.display_name}
                            </option>
                          );
                        })}
                      <option value="others">Others</option>
                    </Input>
                    <Input
                      className="awb-other-input"
                      onChange={this.handleOtherShipping}
                      placeholder="Select other courier"
                    />
                  </>
                ) : (
                  <Input
                    style={{ background: `url(${ArrowDown})` }}
                    value={shippingOption}
                    onChange={this.handleShipping}
                    type="select"
                  >
                    <option value="" disabled selected hidden>
                      Select Courier
                    </option>
                    {listOfCouriers &&
                      listOfCouriers.map((item) => {
                        return (
                          <option value={item.code}>{item.display_name}</option>
                        );
                      })}
                    <option value="others">Others</option>
                  </Input>
                )}
                <Label className="awb-number-label">AWB Number</Label>
                <Input
                  className="awb-number-input"
                  onChange={this.handleChange}
                  placeholder="Enter AWB Number"
                />
              </Form>
            </Col>
          </Row>
          <Row>
            <div className="drop-zone-awb">
              <span>UPLOAD PACKAGE PHOTO</span>
              {this.state.files.length > 0 ? (
                this.state.files.map((f) => (
                  <KickImage
                    src={`${getCacheImage(f.preview)}`}
                    alt={f.preview}
                    className="photo-preview"
                  />
                ))
              ) : (
                <Dropzone
                  onDrop={(files) => this.onDrop(files)}
                  className="drop-zone-area"
                >
                  <div className="drop-zone-wrapper">
                    <KickImage src={BrowseImg} />
                    <span>
                      drop your image here or <strong>browse</strong>
                    </span>
                  </div>
                </Dropzone>
              )}
            </div>
          </Row>
          <Row>
            <Col className="col-without-border col-center">
              <Button
                className="btn-green flat"
                onClick={this.onSubmit}
                disabled={this.state.awbNumber === ""}
              >
                SUBMIT
              </Button>
            </Col>
          </Row>
          <Row style={{ marginBottom: 0 }}>
            <Col style={{ cursor: "pointer" }} className="awb-col">
              <span onClick={this.props.onToggle}>Cancel</span>
            </Col>
          </Row>
        </ModalBody>
      </Modal>
    );
  }
}

AWB.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  className: PropTypes.string,
  classContent: PropTypes.string,
  textTittle: PropTypes.string.isRequired,
  infoInput: PropTypes.string.isRequired,
  onToggle: PropTypes.func.isRequired,
  onClickAcc: PropTypes.func,
  onClickDec: PropTypes.func,
};

AWB.defaultProps = {
  isOpen: false,
  className: "AWB",
  classContent: "AWB",
  textTittle: "Modal Tittle",
  infoInput: "To the Left!",
  onClickAcc: () => { },
  onClickDec: () => { },
  onToggle: () => { },
};

const mapStateToProps = (state) => ({
  listOfCouriers: state.dataPostalCode.couriers.list,
  historyShipping: state.dataPostalCode.shippingHistory,
  dataSaleForIdExpress: state.dataPostalCode.dataSaleForIdExpress,
  isSubmitPickUpSuccess: state.dataPostalCode.idExpressPickUpProcess.status_code,
  IdExpressPickUpProcess: state.dataPostalCode.idExpressPickUpProcess,
  CancelIdExpressPickUpProcess: state.dataPostalCode.cancelIdExpressPickUpProcess,
  countries: state.dataPostalCode.countries.data,
  cities: state.dataPostalCode.cities.data,
  provinces: state.dataPostalCode.provinces.data,
  isEnabledPickupIdExpress: state.dataPostalCode.isEnabledPickupIdExpress,
});

const mapDispatchToProps = (dispatch) => ({
  fetchAllCourier: () => dispatch(fetchAllCourier()),
  getHistoryShipping: () => dispatch(getHistoryShipping()),
  postPickUpIdExpress: (payload) => dispatch(postPickUpIdExpress(payload)),
  fetchPickupIDExpressSettings: () => dispatch(fetchPickupIDExpressSettings()),
  postCancelPickUpIdExpress: (payload) => dispatch(postCancelPickUpIdExpress(payload)),
  getShippingFee: (payload) => dispatch(getShippingFee(payload))
});

export default connect(mapStateToProps, mapDispatchToProps)(AWB);